import { Tab, Tabs } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { TGetServicesCollectionItem } from "../../../../../../api/service/service.types";
import Notes from "../../../../components/Notes/Notes";
import useNotesQuery from "../../../../components/Notes/useNotesQuery";
import { TServicePageTab } from "../../ServicePageContainer";
import ValuationNotes from "../ValuationNotes";

const StyledContainer = styled.div`
  padding: 0.5rem 1rem 1rem;
  padding: 0;
  box-sizing: border-box;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

const StyledTabs = styled(Tabs)`
  padding: 0.5rem 1rem 0.125rem;
  min-height: 2rem;

  .MuiTab-root {
    min-width: 4rem;
    padding: 0.125rem 0.5rem 0.25rem;
    min-height: 2rem;
    text-transform: none;
    opacity: 0.4;

    &.Mui-selected {
      opacity: 1;
    }
  }

  .MuiTabs-fixed:after {
    content: "";
    display: block;
    position: absolute;
    bottom: 0;
    height: 0.25rem;
    background-color: #ddd;
    width: 100%;
    left: 0;
    z-index: 0;
  }

  .MuiTabs-indicator {
    height: 0.25rem;
    background-color: rgb(246, 74, 105);
    z-index: 1;
  }
`;

const StyledTabsWrapper = styled.div``;

const StyledContentWrapper = styled.div`
  flex-grow: 1;
  overflow: hidden;
`;

interface IServiceMorePanelProps {
  service: TGetServicesCollectionItem;
  tab: TServicePageTab;
  onTabChange: (event: React.ChangeEvent<{}>, string: TServicePageTab) => void;
  valuationNotes: string;
  onValuationNotesChange: (notes: string) => void;
}

const ServiceMorePanel = (props: IServiceMorePanelProps) => {
  const { service, tab, onTabChange, onValuationNotesChange, valuationNotes } =
    props;
  const { formatMessage } = useIntl();
  const notesQuery = useNotesQuery(service.id, "Servicios");

  return (
    <StyledContainer>
      <StyledTabsWrapper>
        <StyledTabs value={tab} onChange={onTabChange}>
          <Tab
            label={formatMessage({
              id: "ServiceMorePanel.CoordinatorNotes",
              defaultMessage: "Notas valoración",
            })}
            value="coordinator_notes"
          />
          <Tab
            label={formatMessage(
              {
                id: "ServiceMorePanel.Notes",
                defaultMessage: "Notas{num}",
              },
              {
                num: notesQuery.isSuccess ? ` (${notesQuery.data.length})` : "",
              }
            )}
            value="notes"
          />
        </StyledTabs>
      </StyledTabsWrapper>
      <StyledContentWrapper>
        {tab === "notes" && (
          <Notes
            parentId={service.id}
            moduleName="Servicios"
            notesQuery={notesQuery}
          />
        )}
        {tab === "coordinator_notes" && (
          <ValuationNotes
            service={service}
            onValuationNotesChange={onValuationNotesChange}
            valuationNotes={valuationNotes}
          />
        )}
      </StyledContentWrapper>
    </StyledContainer>
  );
};

export default ServiceMorePanel;
